import { render, staticRenderFns } from "./RegularSubtitle.vue?vue&type=template&id=1eb44824&scoped=true&name=regular-subtitle&"
import script from "./RegularSubtitle.vue?vue&type=script&lang=js&"
export * from "./RegularSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./RegularSubtitle.vue?vue&type=style&index=0&id=1eb44824&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb44824",
  null
  
)

export default component.exports